import { businessDayjs } from '../../core/time/business-calendar';
import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';

dayjs.locale('ja');

@Pipe({ name: 'formatDate', standalone: true })
export class FormatDatePipe implements PipeTransform {
  transform(value: any): string {
    if (!value) return '';
    return businessDayjs(value).format('YYYY/MM/DD(ddd) HH:mm');
  }
}
